import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute";
import { routes } from "./routes";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute
                element={route.element}
                isProtected={route.isProtected}
                allowedRoles={route.allowedRoles}
                skipContactInfoGate={route.skipContactInfoGate}
              />
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
}
